<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 no-gutter">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <web-service-configuration-form v-model="config" :readonly="!editMode" :mode="mode"></web-service-configuration-form>
      <b-row class="justify-content-end mt-3 no-gutters">
        <b-button v-if="mode === 'create'"
        @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canEditConfig"
        @click="editModeActivate" variant="primary">
          <span>{{$t('common.routing.edit_this_config')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canDeleteConfig"
        @click="deleteConfig" variant="primary">
          <i class="fa-light fa-trash"></i>
          <span>{{$t('common.routing.delete_config')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'details' && editMode === true"
          @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import WebServiceConfigurationForm from '@/pages/routing/WebServiceConfigurationForm.vue'

import {loadPage} from '@/helpers/routing'


export default {
  name: 'MessageDetails',
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner,
    'web-service-configuration-form': WebServiceConfigurationForm
  },
  props: {
    mode: {
      type: String,
      default: "create"
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('webServiceConfig_supprimer', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('webServiceConfig_editer', true)
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.webservice_details') : this.$t('Webheader.webservice_add')
    },
  },
  data () {
    return {
      activateSpinner: false,
      config: {},
      editMode: false,
      returnUrl: '/routing/configurationList/WEBSERVICE',
      savedConfig: []
    }
  },
  created () {
    this.activateSpinner = true

    if (this.mode === "details") {
      this.savedConfig = this.$engine.routing.config.clickedConfig
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    createConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === "1") {
        let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn,
          idPod: this.config.certificateConfig.idPod
        }

        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: that.config.privateKeysConfig.name,
            privateKey: that.config.privateKeysConfig.privateKey,
            password: that.config.privateKeysConfig.password,
            passwordVerif: that.config.privateKeysConfig.passwordVerif,
            type: that.config.privateKeysConfig.type,
            idPod: that.config.privateKeysConfig.idPod
          }
          let params = {
            idCertificat: respCertificate.data.idCertificat
          }

          that.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            params.Host = that.config.host,
            params.Port = that.config.port,
            params.URI = that.config.uri,
            params.SSLMode = that.config.sslActive,
            params.Name = that.config.name
            params.idPrivateKey = respPrivateKey.data.idPrivateKey
            that.$engine.routing.config.webService.create(params)
            .then(resp => {
              that.$f7.modal({
                title: that.$t('common.routing.config_added'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
            })
          })
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          login: this.config.login,
          password: this.config.password
          //idCertificate: respCertificate.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          //idPrivateKey: respPrivateKey.data.id
        }
        this.$engine.routing.config.webService.create(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_addition_error'))
        })
      }
    },
    deleteConfig () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.config_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdWebService: that.savedConfig.IdWebService
              }
              that.$engine.routing.config.webService.delete(params)
              .then(resp => {
                that.$f7.alert('', that.$t('common.routing.config_deleted'))
                loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (this.config.sslActive === "1") {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          URIActive: this.config.uriActive,
          URILabel: this.config.uriLabel,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password
        }
        this.$engine.routing.config.webService.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: this.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
        })
        /*let paramsControl = {
        selectedVerifications: this.config.controlConfig.selectedVerif
        }

        let paramsCertif = {
          name: this.config.certificateConfig.name,
          certificate: this.config.certificateConfig.certificate,
          type: this.config.certificateConfig.type,
          password: this.config.certificateConfig.password,
          passwordVerif: this.config.certificateConfig.passwordVerif,
          startDate: this.config.certificateConfig.startDate,
          endDate: this.config.certificateConfig.endDate,
          commonName: this.config.certificateConfig.cn
          //idCertificate: this.savedConfig.idCertificate DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
        }
        this.$engine.security.certificates.create(paramsCertif)
        .then(respCertificate => {
          let paramsPrivateKey = {
            name: this.config.privateKeysConfig.name,
            privateKey: this.config.privateKeysConfig.privateKey,
            password: this.config.privateKeysConfig.password,
            passwordVerif: this.config.privateKeysConfig.passwordVerif,
            type: this.config.privateKeysConfig.type
            //idPrivateKey: respPrivateKey.data.id DRO 17/07/2023 A METTRE QD VHE A FINI COTE MODDE
          }
          this.$engine.security.private_keys.create(paramsPrivateKey)
          .then(respPrivateKey => {
            let params = {
              Host: this.config.host,
              Port: this.config.port,
              URI: this.config.uri,
              SSLMode: this.config.sslActive,
              Name: this.config.name,
              IdWebService: this.savedConfig.IdWebService
            }
            this.$engine.routing.config.webService.edit(params)
            .then(resp => {
              that.$f7.modal({
                title: this.$t('common.routing.config_edited'),
                buttons: [
                  {
                    text: 'OK',
                    onClick: function () {
                      return
                    }
                  }
                ]
              })
              loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
            })
          })
        })*/
        .catch(e => {
          errorMessageAlert(e, that)
          this.okMessageBox(this.$t('common.routing.config_edition_error'))
        })
      } else {
        let params = {
          Host: this.config.host,
          Port: this.config.port,
          URI: this.config.uri,
          URIActive: this.config.uriActive,
          URILabel: this.config.uriLabel,
          SSLMode: this.config.sslActive,
          Name: this.config.name,
          IdWebService: this.savedConfig.IdWebService,
          login: this.config.login,
          password: this.config.password
        }
        this.$engine.routing.config.webService.edit(params)
        .then(resp => {
          that.$f7.modal({
            title: that.$t('common.routing.config_edited'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
          loadPage(that, {url: '/routing/configurationList/WEBSERVICE'})
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('common.routing.config_edition_error'))
        })
      }
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.host = this.savedConfig.Host
      this.config.name = this.savedConfig.Name
      this.config.port = this.savedConfig.Port
      this.config.uri = this.savedConfig.URI
      this.config.uriActive = this.savedConfig.URIActive
      this.config.uriLabel = this.savedConfig.URILabel
      this.config.sslActive = this.savedConfig.SSLMode
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.host === undefined || this.config.host.length === 0) {
        this.okMessageBox(this.$t('common.routing.host_missing'))
        return true
      }
      if (this.config.port === undefined || this.config.port.length === 0) {
        this.okMessageBox(this.$t('common.routing.port_missing'))
        return true
      }
      // if (this.config.uri === undefined || this.config.uri.length === 0) {
      //   this.okMessageBox(this.$t('common.routing.uri_missing'))
      //   return true
      // }
      if (this.config.sslActive === undefined || this.config.sslActive !== "0" && this.config.sslActive !== "1") {
        this.okMessageBox(this.$t('common.routing.wrong_ssl_active'))
        return true
      }
      if (this.config.sslActive === "1") {
        /*if (this.config.controlConfig === undefined || this.config.controlConfig.selectedVerif.length === 0) {
          this.okMessageBox(this.$t('common.global.ctrl_missing'))
          return true
        }
        if (this.config.certificateConfig === undefined) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.name === undefined || this.config.certificateConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_name_missing'))
          return true
        }
        if (this.config.certificateConfig.certificate === undefined || this.config.certificateConfig.certificate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_desc_missing'))
          return true
        }
        if (this.config.certificateConfig.type === undefined || this.config.certificateConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.certif_type_missing'))
          return true
        }
        if (this.config.certificateConfig.password === undefined || this.config.certificateConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.certificateConfig.passwordVerif === undefined || this.config.certificateConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }
        if (this.config.certificateConfig.startDate === undefined || this.config.certificateConfig.startDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_valid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.endDate === undefined || this.config.certificateConfig.endDate.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_unvalid_date_missing'))
          return true
        }
        if (this.config.certificateConfig.cn === undefined || this.config.certificateConfig.cn.length === 0) {
          this.okMessageBox(this.$t('common.security.certif_cn_missing'))
          return true
        }
        if (this.config.privateKeysConfig === undefined) {
          this.okMessageBox(this.$t('common.securityffff'))
          return true
        }
        if (this.config.privateKeysConfig.name === undefined || this.config.privateKeysConfig.name.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_name_missing'))
          return true
        }
        if (this.config.privateKeysConfig.privateKey === undefined || this.config.privateKeysConfig.privateKey.length === 0) {
          this.okMessageBox(this.$t('common.security.priv_key_desc_missing'))
          return true
        }
        if (this.config.privateKeysConfig.type === undefined || this.config.privateKeysConfig.type === "0") {
          this.okMessageBox(this.$t('common.security.priv_key_type_missing'))
          return true
        }
        if (this.config.privateKeysConfig.password === undefined || this.config.privateKeysConfig.password.length === 0) {
          this.okMessageBox(this.$t('common.security.password_missing'))
          return true
        }
        if (this.config.privateKeysConfig.passwordVerif === undefined || this.config.privateKeysConfig.passwordVerif.length === 0) {
          this.okMessageBox(this.$t('common.security.password_verify_missing'))
          return true
        }*/
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/configurationList/WEBSERVICE'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
